import * as skrollTop from 'skrolltop';
import { isMobileRes } from '../../../utils/Utils';

class FAQ {
  constructor() {
    this.main = document.getElementById('faq');

    this._contentIndex = this.main.querySelector('.content_index');
    this._dataContent = [...this.main.querySelectorAll('.data_content')];
    this._isScrolling = false;

    Array.from(this.main.querySelectorAll('.index a')).forEach(btn => {
      btn.addEventListener('click', this._onClickIndexBtn.bind(this));
    });

    history.scrollRestoration = 'manual';
    document.addEventListener('beforeunload', () =>
      setTimeout(() => window.scrollTo(0, 0), 10)
    );

    setTimeout(() => {
      if (
        window.location.hash !== '' &&
        document.getElementById(window.location.hash.substring(1))
      ) {
        this._goTo(window.location.hash.substring(1));
      }
    }, 150);
  }

  _onClickIndexBtn(e) {
    e.preventDefault();

    this._goTo(e.target.getAttribute('data-content-id'));
  }

  _goTo(contentId) {
    let scrollY = document.getElementById(contentId).offsetTop;

    scrollY = isMobileRes() ? scrollY - 80 : scrollY - 100;

    this._isScrolling = true;

    skrollTop.scrollTo({
      element: window,
      to: scrollY,
      duration: 600,
      callback: () => {
        this._isScrolling = false;
      }
    });
  }
}

export default FAQ;